import axios from "axios";
import moment from "moment";
import momenttimezone from "moment-timezone";
import React from "react";
import {useLoaderData, useParams} from "react-router-dom";
import {
    isUrlValid, manageAttractionData, manageVenueData, setAttractionData, setUniqueAttractionAttribute, toastSuccess
} from "./utilities";





export default function MetaDataLinks(data)
{
    const theData = data;
    let params = useParams();
    console.log('metadata links: ', params);

    const handleBlur = e => {
        var eventurl = e.target.value;
        if (eventurl.length > 4 && !isUrlValid(eventurl))
        {
            toastSuccess("URL is invalid");

            return;
        }
        if(e.target.id === 'facebook' && eventurl === 'https://www.facebook.com/' || e.target.id === 'facebook' && eventurl === 'https://facebook.com/' || e.target.id === 'facebook' && eventurl === 'https://facebook.com' || e.target.id === 'facebook' && eventurl === 'https://www.facebook.com')
        {
            toastSuccess("Facebook URL is invalid");
            return;
        }
        if(e.target.id === 'instagram' && eventurl === 'https://www.instagram.com/' || e.target.id === 'instagram' && eventurl === 'https://instagram.com/' || e.target.id === 'instagram' && eventurl === 'https://instagram.com' || e.target.id === 'instagram' && eventurl === 'https://www.instagram.com')
        {
            toastSuccess("Facebook URL is invalid");
            return;
        }
        console.log('handle blur: ', e.target.id);
        if(theData['@type'] === 'Place')
        {
            manageVenueData(e.target.id, e.target.value,params.venueid);
        }
        else
        {
            manageAttractionData(e.target.id, e.target.value,params.id);
        }

        //console.log(text.current);
        //setAttribute(data['guid'], e.target.id, document.getElementById(e.target.id).textContent, true, false);
    };

    const handleAttribute = e => {
        e.preventDefault();
        //console.log(text.current);
        //setAttribute(data['guid'], e.target.id, document.getElementById(e.target.id).textContent, true, false);

    }

    const handlePaste = event => {
        var eventurl = event.clipboardData.getData('text');
        console.log(event);
        if (!isUrlValid(eventurl))
        {
            alert("Invalid URL");

            return;
        }
        else
        {

        }
    };

    const supportedSites = [
        {name: 'Apple Music', id: 'applemusic', type: 'top'},
        {name: 'Bandcamp', id: 'bandcamp', type: 'top'},
        {name: 'Facebook', id: 'facebook', type: 'top'},
        {name: 'Instagram', id: 'instagram', type: 'top'},
        {name: 'SoundCloud', id: 'soundcloud', type: 'top'},
        {name: 'Spotify', id: 'spotify', type: 'top'},
        {name: 'Threads', id: 'threads', type: 'top'},
        {name: 'TikTok', id: 'tiktok', type: 'top'},
        {name: 'Wikipedia', id: 'wikipedia', type: 'top'},
        {name: 'X (Twitter)', id: 'twitter', type: 'top'},
        {name: 'YouTube', id: 'youtube', type: 'top'},

    ]


    return <div className="pt-1">
        <form onSubmit={handleAttribute} key={'website'}>
                    <label htmlFor={'website'} className="block text-sm font-medium text-gray-900">
                        Website
                    </label>
                    <div className="mt-1 flex rounded-md shadow-sm ">
                        <div className="relative flex  flex-grow items-stretch focus-within:z-10 ">
                            <div className="p-2 pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">

                            </div>
                            {data.gogo && data.gogo.webpage && <>
                                <a href={data.gogo.webpage} target="_blank" rel="noreferrer" type={'link'}
                                   className={"relative -ml-px inline-flex items-center gap-x-1.5 rounded-l-md border-r-0 px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50"}>
                                    <i class="fa-solid fa-arrow-up-right-from-square"></i>
                                </a>
                            </>
                            }
                            {data.url && <>
                                <a href={data.url} target="_blank" rel="noreferrer" type={'link'}
                                   className={"relative -ml-px inline-flex items-center gap-x-1.5 rounded-l-md border-r-0 px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50"}>
                                    <i class="fa-solid fa-arrow-up-right-from-square"></i>
                                </a>
                            </>
                            }

                            <input
                                    type="text"
                                    name="value"
                                    id={'website'}
                                    className="block w-full rounded-none border-0 py-1.5 pl-2 ring-1 ring-inset ring-gray-300  focus:ring-2 focus:ring-inset focus:ring-indigo-600  tracking-tight text-gray-900"
                                    defaultValue={data.gogo && data.gogo.webpage && data.gogo.webpage || data.url}
                                    onBlur={handleBlur}
                            />
                        </div>
                        <button
                                type="submit"
                                className="relative -ml-px inline-flex items-center gap-x-1.5 rounded-r-md px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                        >

                            Save
                        </button>
                    </div>

                </form>

        {supportedSites.map((site,index) => (
                <form onSubmit={handleAttribute} key={site.id}>
                    <label htmlFor={site.id} className="block text-sm font-medium text-gray-900">
                        {site.name}
                    </label>
                    <div className="mt-1 flex rounded-md shadow-sm">
                        <div className="relative flex flex-grow items-stretch focus-within:z-10">
                            <div className="p-2 pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">

                            </div>
                            {data.gogo && data.gogo[site.id] && <>
                                <a href={data.gogo && data.gogo[site.id]} target="_blank" rel="noreferrer" type={'link'}
                                   className={"relative -ml-px inline-flex items-center gap-x-1.5 rounded-l-md px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 border-r-0"}>
                                    <i class="fa-solid fa-arrow-up-right-from-square"></i>
                                </a>
                            </>
                            }
                            <input
                                    type="text"
                                    name="value"
                                    id={site.id}
                                    className="block w-full rounded-none border-0 py-1.5 pl-2 ring-1 ring-inset ring-gray-300 border-l-0  focus:ring-2 focus:ring-inset focus:ring-indigo-600  tracking-tight text-gray-900"
                                    defaultValue={data.gogo && data.gogo[site.id]}
                                    onBlur={handleBlur}
                                    onPaste={pasteEvent => handlePaste(pasteEvent)}
                            />
                        </div>
                        <button
                                type="submit"
                                className="relative -ml-px inline-flex items-center gap-x-1.5 rounded-r-md px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                        >

                            Save
                        </button>
                    </div>

                </form>
        ))}
    </div>

}



